import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-empty',
    templateUrl: './empty.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmptyComponent {
  @Input() public rows: any[] = [];
  @Input() public type: string;

  constructor() {}
}
